<template>
    <div class="container header-margin">
        <div class="text-center p-2 text-color text-area">
            <h2 class="main_title">{{ $t('aube_quest.registration.title_error') }}</h2>
        </div>

        <div class="info-box">
            <small class="text-muted">{{ $t('aube_quest.registration.title_quest_info') }}</small>
            <div>Quest ID: {{ quest_id }}</div>
            <div>Connector ID: {{ connectorMemberId }}</div>
            <div>{{ $t('aube_quest.connector_start_date') }}: {{ joinedDate }}</div>
        </div>

        <div class="text-center p-2">
            <div v-if="this.message == 'userTokenDataWithin24H'" class="show-check-email-message" v-html="$t('auth.notLatestTokenText')"></div>
            <div v-if="this.message == 'notExistToken'" class="show-check-email-message" v-html="$t('auth.notExistToken')">
                <!-- トークンデータが存在しない -->
            </div>
            <div v-if="this.message == 'timeOverToken'" class="show-check-email-message" v-html="$t('aube_quest.registration.tokenRegistrationTimeOverText')">
                <!-- トークンデータ24時間超過 -->
            </div>
            <div v-if="this.message == 'notLatestToken'" class="show-check-email-message" v-html="$t('auth.notLatestTokenText')">
                <!-- 最新ではないトークンデータ -->
            </div>
            <div v-if="this.message == 'QUEST_CONNECTED'" class="show-check-email-message" v-html="$t('errors.QUEST_CONNECTED')">
                <!-- 最新ではないトークンデータ -->
            </div>
        </div><br />
        <div class="text-center">
            <div class="pb-4 ">
                <a class="btn btn-primary text-center-btn" href="https://www.aube-quest.com/login" role="button">{{$t('aube_quest.btn_close') }}</a>
            </div>
        </div>
    </div>
</template>

<script>
    import questService from "../../../../services/QuestService";

    export default {
        name: 'registration-error-module',
        data() {
            return {
                quest_id: '',
                connectorMemberId: '',
                joinedDate: '',
            }
        },
        created() {
            this.message = this.$route.query.message;
            this.quest_id = this.$route.query.quest_id || '';
            this.getConnector(this.quest_id);
        },
         methods: {
             async getConnector (questId) {
                 try {
                     const result = await questService.getConnectorByQuestId(questId);
                     this.connectorMemberId = result.data.connector_id;
                     this.joinedDate = result.data.joined_date;
                 } catch (error) {
                 }
             }
         }
    }
</script>

<style scoped>
    .text-color {
        color: #451493;
    }
    .text-area {
        padding-bottom: 20px;
    }
    .main_title {
        margin-bottom:15px;
    }
    .main_title {
        font-size: 1.575rem;
        margin-bottom: 0px;
    }
    .pre {
        white-space: pre-wrap;
    }
    .show-check-email-message {
        text-align: center;
        color: red;
    }
    .show-check-email-message >>> br {
        display: inline;
    }
    .btn-primary {
        width: 130px;
    }
    .info-box {
        background-color: #f7f7f7;
        border-radius: 6px;
        padding: 12px 16px;
        margin-bottom: 20px;
        margin-top: 20px;
        border: 1px solid #ebeaea;
        max-width: 600px;
        margin-left: auto;
        margin-right: auto;
    }
    .info-box small {
        display: block;
        color: #6c757d;
        margin-bottom: 4px;
        font-size: 0.85rem;
    }
    .info-box div {
        font-weight: 500;
        font-size: 0.95rem;
    }
    @media screen and (max-width: 767px) {
        .show-check-email-message {
            text-align: left;
        }
        .show-check-email-message >>> br {
            display: none;
        }
    }
</style>
